module.exports = __webpack_public_path__ + "static/woyw-2-9091ebf004d3c7a59f6820db985bd99e.png";